// extracted by mini-css-extract-plugin
export default {"desktopFilters":"_1ZHXY","desktopFilters__heading":"_1WlFk","filterText":"_240rq","clearAllBtn":"_29T91","link":"aiDsa","filters__collapsible":"_25O8B"};